import axios, { AxiosError } from 'axios';
import { useSelector } from 'react-redux';

import { useAxiosQuery, UseAxiosQueryOptions } from '@hooks/useAxiosQuery';

import { getCurrencyState, getLocaleState } from '@redux/selectors';

import { FlightFareResult } from '@wegoTypes/flights/metasearch/flightFareResult';

export const getFlightTripDetailsKey = 'flight-trip-details';

type GetFlightTripDetailsParams = {
  tripId: string;
  paymentMethodIds: Array<number>;
  clientId: string | undefined;
  includeAirlineBackfill?: boolean;
};

export const useGetFlightTripDetails = (
  params: GetFlightTripDetailsParams,
  options?: UseAxiosQueryOptions<
    FlightFareResult,
    FlightFareResult,
    AxiosError<{ code: number; message: string }>
  >,
) => {
  const locale = useSelector(getLocaleState);
  const currencyCode = useSelector(getCurrencyState);

  return useAxiosQuery({
    queryKey: [
      getFlightTripDetailsKey,
      {
        locale,
        currencyCode: currencyCode.code,
        ...params,
      },
    ],
    queryFn: async () => {
      const response = await axios.get(
        `${API_BASE_URL}/v5/metasearch/flights/trips/${params.tripId}`,
        {
          params: {
            locale,
            currencyCode: currencyCode.code,
            paymentMethodIds: params.paymentMethodIds,
            clientId: params.clientId,
            ...(params.includeAirlineBackfill && {
              includeAirlineBackfill: params.includeAirlineBackfill,
            }),
          },
        },
      );

      if (response.status === 200) {
        return response.data;
      }

      throw new Error(response.statusText);
    },
    staleTime: 1000 * 60 * 30, // 30 minutes
    ...options,
  });
};
